import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_management" }, { title: "menu_sidebar_management_sale_point" }];

const SalePointManagementListing = Loadable({
  loader: () => import("container/management/salePoint"),
  loading() {
    return <Loader />;
  }
});
export const salePointRoutes: IRoute[] = [
  {
    path: "/management/salepoint",
    element: <SalePointManagementListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
